"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeStickyPriceWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var journey_services_1 = require("@athena-portal/journey-services");
var React = require("react");
var AnnualHomeStickyPriceWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeStickyPriceWidget, _super);
    function AnnualHomeStickyPriceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.visibilityBreakPoint = 250;
        _this.showOnScroll = function () {
            if (_this.state.visibilityClass === "d-none") {
                if (window.scrollY > _this.visibilityBreakPoint) {
                    _this.setState({ visibilityClass: "show" });
                }
            }
            else {
                if (window.scrollY > _this.visibilityBreakPoint) {
                    _this.setState({ visibilityClass: "show" });
                }
                else {
                    _this.setState({ visibilityClass: "hide" });
                }
            }
            var tierTableElements = document.getElementsByClassName("tier-table");
            if (tierTableElements.length > 0) {
                var tierTable = tierTableElements[0];
                var tierRect = tierTable.getBoundingClientRect();
                if (tierRect.top <= 0 && tierRect.bottom >= 0) {
                    _this.setState({ showTierPremiums: true });
                }
                else {
                    _this.setState({ showTierPremiums: false });
                }
            }
        };
        _this.state = {
            visibilityClass: "d-none",
            showTierPremiums: false
        };
        window.addEventListener("scroll", _this.showOnScroll);
        return _this;
    }
    AnnualHomeStickyPriceWidget.prototype.render = function () {
        var cssClass = this.getSetting("cssClass", "");
        return (React.createElement("div", { className: "sticky-price ".concat(cssClass, " quote ").concat(this.state.visibilityClass).concat(this.state.showTierPremiums ? " tiers pt-0" : "") },
            React.createElement("div", { className: this.state.showTierPremiums ? "container" : "sticky-price-background" }, this.state.showTierPremiums ?
                this.renderTierTables() :
                this.renderSelectedPremium())));
    };
    AnnualHomeStickyPriceWidget.prototype.renderSelectedPremium = function () {
        var premium;
        var wording;
        if (this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL) {
            premium = this.props.interaction.factors.annualPremium;
            wording = " / year*";
        }
        else {
            premium = this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
            wording = " / month*";
        }
        return (React.createElement("div", { className: "d-inline-block" },
            (0, commonFunctions_1.getAmountWithDecimalDigits)(premium),
            React.createElement("span", { className: "fs-18" }, wording)));
    };
    AnnualHomeStickyPriceWidget.prototype.renderTierTables = function () {
        var _this = this;
        var tiers = new Map();
        var renderTier = this.props.interaction.eligibleTier !== services_1.SILVER_TIER;
        var bronzeHidden = this.props.interaction.eligibleTier === services_1.SILVER_TIER ? " bronze-hidden" : "";
        if (renderTier) {
            tiers.set(services_1.BRONZE_TIER, "Bronze");
        }
        tiers.set(services_1.SILVER_TIER, "Silver");
        tiers.set(services_1.GOLD_TIER, "Gold");
        var rows = [];
        tiers.forEach(function (tierName, code) {
            rows.push(_this.renderTierPremium(code, tierName));
        });
        return (React.createElement("div", { className: "journey-content" },
            React.createElement("div", { className: "row mr-0 ml-0 sticky-tiers" + bronzeHidden },
                React.createElement("div", { className: "col-4" }),
                rows)));
    };
    AnnualHomeStickyPriceWidget.prototype.renderTierPremium = function (tier, tierName) {
        var _this = this;
        var factors = this.props.interaction.factors;
        var premiumType = factors.premiumType;
        var isSelected = this.props.interaction.coverTier === tier;
        var wrapperClass = isSelected ? "background-color-primary" : "";
        var annualPremium;
        var monthlyPremium;
        if (tier === services_1.BRONZE_TIER) {
            annualPremium = factors.bronzePremiums.totalAnnualPremium;
            monthlyPremium = factors.bronzePremiums.totalMonthlyPremium;
        }
        else if (tier === services_1.SILVER_TIER) {
            annualPremium = factors.silverPremiums.totalAnnualPremium;
            monthlyPremium = factors.silverPremiums.totalMonthlyPremium;
        }
        else {
            annualPremium = factors.goldPremiums.totalAnnualPremium;
            monthlyPremium = factors.goldPremiums.totalMonthlyPremium;
        }
        return (React.createElement("div", { className: "col ".concat(wrapperClass), onClick: function (event) { return _this.handleChange(tier); } },
            React.createElement("div", { className: "font-semi-bold tier-premium-display" }, premiumType === "annual" ?
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "custom-radiobutton-container" },
                        React.createElement("input", { className: "custom-radiobutton", type: "radio", name: this.props.question.name, key: tier + "input", value: tier, id: this.props.question.name + tier, checked: isSelected })),
                    React.createElement("div", { className: "tier-name" }, tierName),
                    React.createElement("div", { className: "d-flex" },
                        (0, commonFunctions_1.getAmountWithDecimalDigits)(annualPremium),
                        React.createElement("p", { className: "font-light text-color-dark" }, " / year*"))) :
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "custom-radiobutton-container" },
                        React.createElement("input", { className: "custom-radiobutton", type: "radio", name: this.props.question.name, key: tier + "input", value: tier, id: this.props.question.name + tier, checked: isSelected })),
                    React.createElement("div", { className: "tier-name" }, tierName),
                    React.createElement("div", { className: "d-flex" },
                        (0, commonFunctions_1.getAmountWithDecimalDigits)(monthlyPremium),
                        React.createElement("p", { className: "font-light text-color-dark" }, " / month*"))))));
    };
    AnnualHomeStickyPriceWidget.prototype.handleChange = function (selectedTier) {
        this.recordPreviousTierLevel();
        journey_services_1.ObjectManipulator.setField("coverTier", this.props.interaction, selectedTier);
        var prevTierLevel = this.props.interaction.uistate.annualHomeAddonsState.previousTierLevel;
        if (prevTierLevel !== services_1.GOLD_TIER) {
            this.recordPreviousAddons();
        }
        this.resetAddons(selectedTier === services_1.GOLD_TIER);
        if (selectedTier === services_1.GOLD_TIER) {
            this.updatePossessions(true);
        }
        else {
            this.updatePossessions(false);
        }
        this.executeEvent("change");
    };
    AnnualHomeStickyPriceWidget.prototype.resetAddons = function (isPremier) {
        var annualHomeAddonsState = this.props.interaction.uistate.annualHomeAddonsState;
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.buildingAccidentalDamage", this.props.interaction, isPremier ? true : annualHomeAddonsState.buildingAccidentalDamage);
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.contentsAccidentalDamage", this.props.interaction, isPremier ? true : annualHomeAddonsState.contentsAccidentalDamage);
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.homeLegalExpenses", this.props.interaction, isPremier ? true : annualHomeAddonsState.homeLegalExpenses);
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.homeEmergency", this.props.interaction, isPremier ? true : annualHomeAddonsState.homeEmergency);
    };
    AnnualHomeStickyPriceWidget.prototype.recordPreviousAddons = function () {
        var annualHomeFixedAddons = this.props.interaction.annualHomeFixedAddons;
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.buildingAccidentalDamage", this.props.interaction, annualHomeFixedAddons.buildingAccidentalDamage);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.contentsAccidentalDamage", this.props.interaction, annualHomeFixedAddons.contentsAccidentalDamage);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.homeLegalExpenses", this.props.interaction, annualHomeFixedAddons.homeLegalExpenses);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.homeEmergency", this.props.interaction, annualHomeFixedAddons.homeEmergency);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.personalPossessionCoverLimit", this.props.interaction, this.props.interaction.annualHomeExtraCovers.personalPossessionCoverLimit);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.personalPossessionsCover", this.props.interaction, this.props.interaction.annualHomeExtraCovers.personalPossessionsCover);
    };
    AnnualHomeStickyPriceWidget.prototype.recordPreviousTierLevel = function () {
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.previousTierLevel", this.props.interaction, this.props.interaction.coverTier);
    };
    AnnualHomeStickyPriceWidget.prototype.updatePossessions = function (value) {
        journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionsCover", this.props.interaction, value ? value : this.props.interaction.uistate.annualHomeAddonsState.personalPossessionsCover);
        var personalPossessionCoverLimit = this.props.interaction.annualHomeExtraCovers.personalPossessionCoverLimit;
        var premierPersonalPossessionCoverLimit = personalPossessionCoverLimit >= 2000 ? personalPossessionCoverLimit : 2000;
        journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionCoverLimit", this.props.interaction, value ? premierPersonalPossessionCoverLimit : this.props.interaction.uistate.annualHomeAddonsState.personalPossessionCoverLimit);
    };
    return AnnualHomeStickyPriceWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeStickyPriceWidget = AnnualHomeStickyPriceWidget;
//# sourceMappingURL=AnnualHomeStickyPriceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomeStickyPriceWidget.js
// module id = 3694
// module chunks = 0